import classnames from 'classnames/bind'
import React from 'react'

import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface Icons {
  image?: ImageProps
  text?: RichTextBlock[]
  title?: RichTextBlock[]
}

export interface ListIconsProps {
  className?: string
  items?: Icons[]
}
/**
 * List icons slice
 * @param props
 * @returns Slice
 */
function ListIcons({ className, items }: ListIconsProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-heading-4' })
  const textStyle = useStyle({ textPreset: 'text-paragraph' })

  return (
    <section className={cx(css.ListIcons, className)}>
      {items?.map((item, index) => (
        <div className={css.icon} key={`icon${index}`}>
          {item?.image && (
            <div className={css.imageContainer}>
              <ImageWithPlaceHolder
                className={css.image}
                layout="fill"
                objectFit="contain"
                {...item.image}
              />
            </div>
          )}
          {item?.title && (
            <RichText
              className={cx(css.title, titleStyle)}
              render={item.title}
            />
          )}
          {item?.text && (
            <RichText className={cx(css.text, textStyle)} render={item.text} />
          )}
        </div>
      ))}
    </section>
  )
}

ListIcons.defaultProps = {}

export default ListIcons
